import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'smart-rate.title',
    defaultMessage: 'SmartRate',
  },
  statusOn: {
    id: 'smart-rate.status.on',
    defaultMessage: 'SmartRate On',
  },
  faqTitle: {
    id: 'smart-rate.faq.title',
    defaultMessage: 'Frequently asked questions',
  },
});
